import methods from '@/enums/methods';
import TransactionMonitoringService from './base';

class DefaultParamService extends TransactionMonitoringService {
    show(mcc) {
        return this.fetch({
            url: `${this.baseUrl}/default-params/${mcc}`,
        });
    }

    update({ mcc, payload }) {
        return this.fetch({
            data: payload,
            url: `${this.baseUrl}/default-params/${mcc}`,
            method: methods.PUT,
        });
    }
}

export default new DefaultParamService();
